import * as lodash from "lodash";
import {TCITenantAppCategory, TCITenantAppType} from "./tci-application";
import {ITCIApplicationCreateOption, TCI_CREATE_APP_UI_TYPE} from "./tci-app-create";


/*************************************************************************************************/



/*************************************************************************************************/
/*                        TCI AppType Metadata                                                   */

/*************************************************************************************************/

export class TCIApplicationCreateCategory {
    public static QUICKSTART = new TCIApplicationCreateCategory(
        "Quickstart",
        "ng-app-ic-quickstart.svg",
        "CAT_QUICKSTART"
    );
    public static APPLICATION_INTEGRATION = new TCIApplicationCreateCategory(
        "Application Integration",
        "ng-app-ic-appintegration.svg",
        "CAT_APPLICATION_INTEGRATION"
    );
    public static DATA_INTEGRATION = new TCIApplicationCreateCategory(
        "Data Integration",
        "ng-app-ic-dataintegration.svg",
        "CAT_DATA_INTEGRATION"
    );
    public static PROCESS_AUTOMATION = new TCIApplicationCreateCategory(
        "Process Automation",
        "ng-app-ic-processautomation.svg",
        "CAT_PROCESS_AUTOMATION"
    );
    public static SCRATCH = new TCIApplicationCreateCategory(
        "Create from scratch or import",
        "",
        "CAT_SCRATCH"
    );

    constructor(
        public label: string,
        public iconUrl: string,
        public id: string
    ) {
    }

    public static getAllItems(): TCIApplicationCreateCategory[] {
        return [
            TCIApplicationCreateCategory.QUICKSTART,
            TCIApplicationCreateCategory.APPLICATION_INTEGRATION,
            TCIApplicationCreateCategory.DATA_INTEGRATION,
            TCIApplicationCreateCategory.PROCESS_AUTOMATION,
        ];
    }
}
export class TCIApplicationCreateOptionSubButton implements ITCIApplicationCreateOption {
    public static SCRIBE_CREATE_SCHEDULED_APP = new TCIApplicationCreateOptionSubButton(
        0,
        TCITenantAppType.scribe,
        TCI_CREATE_APP_UI_TYPE.DEFAULT_UI,
        "Create Scheduled app",
        "pendo_btn_create_scheduled_app"
    );
    public static SCRIBE_CREATE_EVENT_APP = new TCIApplicationCreateOptionSubButton(
        1,
        TCITenantAppType.scribe,
        TCI_CREATE_APP_UI_TYPE.DEFAULT_UI,
        "Create Event app",
        "pendo_btn_create_event_app"
    );
    public static SCRIBE_CREATE_DATA_REPLICATION_APP = new TCIApplicationCreateOptionSubButton(
        2,
        TCITenantAppType.scribe,
        TCI_CREATE_APP_UI_TYPE.DEFAULT_UI,
        "Create Data Replication app",
        "pendo_btn_create_data_replication_app"
    );

    public static FLOGO_APP_INTEGRATION = new TCIApplicationCreateOptionSubButton(
        3,
        TCITenantAppType.flogo,
        TCI_CREATE_APP_UI_TYPE.DEFAULT_UI,
        "Create Flogo app",
        "pendo_btn_create_flogo_app"
    );

    public static FLOGO_APP_IMPORT = new TCIApplicationCreateOptionSubButton(
        4,
        TCITenantAppType.flogo,
        TCI_CREATE_APP_UI_TYPE.FILE_UPLOAD,
        "Import Flogo app",
        "pendo_btn_import_flogo_app"
    );

    // No longer applicable
    // public static MOCK_APP_INTEGRATION = new TCIApplicationCreateOptionSubButton(
    //     5,
    //     TCITenantAppType.mock,
    //     TCI_CREATE_APP_UI_TYPE.DEFAULT_UI,
    //     "Mock app integration"
    // );

    public static BW_APP_IMPORT = new TCIApplicationCreateOptionSubButton(
        6,
        TCITenantAppType.bw,
        TCI_CREATE_APP_UI_TYPE.FILE_UPLOAD,
        "Import BusinessWorks app",
        "pendo_btn_import_businessworks_app"
    );

    public static NODE_APP_IMPORT = new TCIApplicationCreateOptionSubButton(
        7,
        TCITenantAppType.node,
        TCI_CREATE_APP_UI_TYPE.FILE_UPLOAD,
        "Import Node.js app",
        "pendo_btn_import_nodejs_app"
    );

    // No longer applicable
    // public static FLOGO_IMPORT_API_SPEC = new TCIApplicationCreateOptionSubButton(
    //     8,
    //     TCITenantAppType.flogo,
    //     TCI_CREATE_APP_UI_TYPE.FILE_UPLOAD,
    //     "Import Flogo API spec"
    // );

    public static FLOGO_IMPORT_GRAPHQL_SPEC = new TCIApplicationCreateOptionSubButton(
        9,
        TCITenantAppType.flogo,
        TCI_CREATE_APP_UI_TYPE.FILE_UPLOAD,
        "Import GraphQL file",
        "pendo_btn_import_graphql_file"
    );

    public static FLOGO_SELECT_OPEN_API_SPEC = new TCIApplicationCreateOptionSubButton(
        10,
        TCITenantAppType.flogo,
        TCI_CREATE_APP_UI_TYPE.API_CHOOSER,
        "Import OpenAPI spec",
        "pendo_btn_import_openapi_spec"
    );

    // No longer applicable
    // public static FLOGO_SELECT_GRAPHQL_API_SPEC = new TCIApplicationCreateOptionSubButton(
    //     11,
    //     TCITenantAppType.flogo,
    //     TCI_CREATE_APP_UI_TYPE.API_CHOOSER,
    //     "Select GraphQL API spec"
    // );

    // No longer applicable
    // public static NODE_APP_API_SPEC = new TCIApplicationCreateOptionSubButton(
    //     12,
    //     TCITenantAppType.node,
    //     TCI_CREATE_APP_UI_TYPE.FILE_UPLOAD,
    //     "Import Node file"
    // );

    public static LIVE_APPS_WIZARD = new TCIApplicationCreateOptionSubButton(
        13,
        TCITenantAppType.liveapps,
        TCI_CREATE_APP_UI_TYPE.EXTERNAL_URL,
        "Create LiveApps app",
        "pendo_btn_create_liveapps_app"
    );

    public static LIVE_IMPORT_APPS = new TCIApplicationCreateOptionSubButton(
        14,
        TCITenantAppType.liveapps,
        TCI_CREATE_APP_UI_TYPE.EXTERNAL_URL,
        "Import LiveApps app",
        "pendo_btn_import_liveapps_app"
    );

    public static SCRIBE_IMPORT_EVENT_APP = new TCIApplicationCreateOptionSubButton(
        15,
        TCITenantAppType.scribe,
        TCI_CREATE_APP_UI_TYPE.FILE_UPLOAD,
        "Import Event app",
        "pendo_btn_import_event_app"
    );
    public static SCRIBE_IMPORT_SCHEDULED_APP = new TCIApplicationCreateOptionSubButton(
        16,
        TCITenantAppType.scribe,
        TCI_CREATE_APP_UI_TYPE.FILE_UPLOAD,
        "Import Scheduled app",
        "pendo_btn_import_scheduled_app"
    );

    public static isTenantUploadButton(button: TCIApplicationCreateOptionSubButton): boolean {
        return lodash.some([
            TCIApplicationCreateOptionSubButton.NODE_APP_IMPORT,
            TCIApplicationCreateOptionSubButton.BW_APP_IMPORT,
            TCIApplicationCreateOptionSubButton.SCRIBE_IMPORT_SCHEDULED_APP,
            TCIApplicationCreateOptionSubButton.SCRIBE_IMPORT_EVENT_APP,
            TCIApplicationCreateOptionSubButton.FLOGO_APP_IMPORT,
            TCIApplicationCreateOptionSubButton.FLOGO_IMPORT_GRAPHQL_SPEC
        ], button);
    }

    constructor(
        public option: number,
        public type: TCITenantAppType,
        public uiType: TCI_CREATE_APP_UI_TYPE,
        public label: string,
        public pendoSelector: string
    ) {
    }

    valueOf(): number {
        return this.option;
    }

    equals(that: any): boolean {
        // Shortcut for trivial case
        if (this === that) {
            return true;
        }

        // If the that object is not a set, it is not equal to this one.
        // We use instanceof to allow any subclass of Set.
        // We could relax this test if we wanted true duck-typing.
        // Or we could strengthen it to check this.constructor == that.constructor
        // Note that instanceof properly rejects null and undefined values
        if (!(that instanceof TCIApplicationCreateOptionSubButton)) {
            return false;
        }
        // If two sets don't have the same size, they're not equal

        if (this.valueOf() !== that.valueOf()) {
            return false;
        }

        return lodash.isEqual(this, that);
    }

    toString(): string {
        return "" + this.option;
    }
}

export class TCIApplicationCreateOption implements ITCIApplicationCreateOption {
    public static IMPORT_A_NODEJS_APP = new TCIApplicationCreateOption(
        0,
        TCITenantAppType.node,
        TCITenantAppCategory.DEVELOP,
        "Import a Node.JS app",
        [TCIApplicationCreateOptionSubButton.NODE_APP_IMPORT],
        "pendo_import_a_nodejs_app"
    );
    public static IMPORT_A_BUSINESSWORKS_APP = new TCIApplicationCreateOption(
        1,
        TCITenantAppType.bw,
        TCITenantAppCategory.INTEGRATE,
        "Import a BusinessWorks app",
        [TCIApplicationCreateOptionSubButton.BW_APP_IMPORT],
        "pendo_import_a_businessworks_app"
    );
    // public static CREATE_FROM_A_NEW_API_SPEC = new TCIApplicationCreateOption(
    //     2,
    //     TCITenantAppType.modeler,
    //     TCITenantAppCategory.DEVELOP,
    //     "Create from a New API Spec",
    //     [TCIApplicationCreateOptionSubButton.MOCK_APP_INTEGRATION]
    // );

    // flogo has 4 different sub buttons.
    public static IMPLEMENT_AN_OPENAPI_SPEC = new TCIApplicationCreateOption(
        3,
        TCITenantAppType.flogo,
        TCITenantAppCategory.DEVELOP,
        "Create an app from OpenAPI",        // Flogo API Specification -> API Specs
        [TCIApplicationCreateOptionSubButton.FLOGO_SELECT_OPEN_API_SPEC],
        "pendo_create_an_app_from_openapi"
    );
    // No longer applicable
    // Note: this option is a sub tab of "Implement an OpenAPI Spec"
    // public static IMPORT_A_OPEN_API_SPEC = new TCIApplicationCreateOption(
    //     4,
    //     TCITenantAppType.flogo,
    //     TCITenantAppCategory.DEVELOP,
    //     "Import a Open API Spec",           // Flogo API Specification -> upload file
    //     [
    //         TCIApplicationCreateOptionSubButton.FLOGO_IMPORT_API_SPEC
    //     ]
    // );
    public static IMPORT_A_GRAPHQL_SCHEMA = new TCIApplicationCreateOption(
        5,
        TCITenantAppType.flogo,
        TCITenantAppCategory.DEVELOP,
        "Create an app from GraphQL",          // Flogo GraphQL Schema
        [TCIApplicationCreateOptionSubButton.FLOGO_IMPORT_GRAPHQL_SPEC],
        "pendo_create_an_app_from_graphql"
    );
    public static CREATE_A_FLOGO_APP = new TCIApplicationCreateOption(
        6,
        TCITenantAppType.flogo,
        TCITenantAppCategory.DEVELOP,
        "Create a Flogo app",               // current default flogo Flow
        [TCIApplicationCreateOptionSubButton.FLOGO_APP_INTEGRATION],
        "pendo_create_a_flogo_app"
    );
    public static IMPORT_A_FLOGO_APP = new TCIApplicationCreateOption(
        7,
        TCITenantAppType.flogo,
        TCITenantAppCategory.DEVELOP,
        "Import a Flogo app",               // New, upload flogo app json file
        [TCIApplicationCreateOptionSubButton.FLOGO_APP_IMPORT],
        "pendo_import_a_flogo_app"
    );

    // scribe has 5 different buttons.
    public static CREATE_A_EVENT_APP = new TCIApplicationCreateOption(
        8,
        TCITenantAppType.scribe,
        TCITenantAppCategory.CONNECT_EVENT,
        "Create an Event app",
        [TCIApplicationCreateOptionSubButton.SCRIBE_CREATE_EVENT_APP],
        "pendo_create_an_event_app"
    );
    public static CREATE_A_SCHEDULED_APP = new TCIApplicationCreateOption(
        9,
        TCITenantAppType.scribe,
        TCITenantAppCategory.CONNECT_SCHEDULE,
        "Create a Scheduled app",
        [TCIApplicationCreateOptionSubButton.SCRIBE_CREATE_SCHEDULED_APP],
        "pendo_create_a_scheduled_app"
    );
    public static CREATE_A_REPLICATION_APP = new TCIApplicationCreateOption(
        10,
        TCITenantAppType.scribe,
        TCITenantAppCategory.CONNECT_REPLICATION,
        "Create a Data Replication app",
        [TCIApplicationCreateOptionSubButton.SCRIBE_CREATE_DATA_REPLICATION_APP],
        "pendo_create_a_data_replication_app"
    );
    public static IMPORT_A_EVENT_APP = new TCIApplicationCreateOption(
        11,
        TCITenantAppType.scribe,
        TCITenantAppCategory.CONNECT_EVENT,
        "Import an Event app",              // New, upload scribe event json file
        [TCIApplicationCreateOptionSubButton.SCRIBE_IMPORT_EVENT_APP],
        "pendo_import_an_event_app"
    );
    public static IMPORT_A_SCHEDULED_APP = new TCIApplicationCreateOption(
        12,
        TCITenantAppType.scribe,
        TCITenantAppCategory.CONNECT_SCHEDULE,
        "Import a Scheduled app",           // New, upload scribe scheduled json file
        [TCIApplicationCreateOptionSubButton.SCRIBE_IMPORT_SCHEDULED_APP],
        "pendo_import_a_scheduled_app"
    );

    public static CREATE_A_LIVEAPPS_APP = new TCIApplicationCreateOption(
        13,
        TCITenantAppType.liveapps,
        TCITenantAppCategory.AUTOMATE,
        "Create a LiveApps app",
        [TCIApplicationCreateOptionSubButton.LIVE_APPS_WIZARD],
        "pendo_create_a_liveapps_app"
    );
    public static IMPORT_A_LIVE_APPS_APP = new TCIApplicationCreateOption(
        14,
        TCITenantAppType.liveapps,
        TCITenantAppCategory.AUTOMATE,
        "Import a Liveapps app",
        [TCIApplicationCreateOptionSubButton.LIVE_IMPORT_APPS],
        "pendo_import_a_liveapps_app"
    );

    public static allOptions = [
        TCIApplicationCreateOption.IMPORT_A_NODEJS_APP,
        TCIApplicationCreateOption.IMPORT_A_BUSINESSWORKS_APP,
        // TCIApplicationCreateOption.CREATE_FROM_A_NEW_API_SPEC,

        TCIApplicationCreateOption.IMPLEMENT_AN_OPENAPI_SPEC,
        // TCIApplicationCreateOption.IMPORT_A_OPEN_API_SPEC,
        TCIApplicationCreateOption.IMPORT_A_GRAPHQL_SCHEMA,
        TCIApplicationCreateOption.CREATE_A_FLOGO_APP,
        TCIApplicationCreateOption.IMPORT_A_FLOGO_APP,

        TCIApplicationCreateOption.CREATE_A_EVENT_APP,
        TCIApplicationCreateOption.CREATE_A_SCHEDULED_APP,
        TCIApplicationCreateOption.CREATE_A_REPLICATION_APP,
        TCIApplicationCreateOption.IMPORT_A_EVENT_APP,
        TCIApplicationCreateOption.IMPORT_A_SCHEDULED_APP,

        TCIApplicationCreateOption.CREATE_A_LIVEAPPS_APP,
        // TCIApplicationCreateOption.IMPORT_A_LIVE_APPS_APP,
    ];

    public static getDefaultOption(tenantType: TCITenantAppType): ITCIApplicationCreateOption {
        let defaultButton: ITCIApplicationCreateOption = null;
        TCIApplicationCreateOption.allOptions
            .forEach(item => {
                if (item.type.equals(tenantType)) {
                    defaultButton = item.subButtons[0] as ITCIApplicationCreateOption;
                }
            });
        return defaultButton;
    }

    constructor(
        public option: number,
        public type: TCITenantAppType,
        public capability: TCITenantAppCategory,
        public label: string,
        public subButtons: TCIApplicationCreateOptionSubButton[],
        public pendoSelector: string
    ) {
    }

    valueOf(): number {
        return this.option;
    }

    equals(that: any): boolean {
        // Shortcut for trivial case
        if (this === that) {
            return true;
        }

        // If the that object is not a set, it is not equal to this one.
        // We use instanceof to allow any subclass of Set.
        // We could relax this test if we wanted true duck-typing.
        // Or we could strengthen it to check this.constructor == that.constructor
        // Note that instanceof properly rejects null and undefined values
        if (!(that instanceof TCIApplicationCreateOption)) {
            return false;
        }
        // If two sets don't have the same size, they're not equal

        if (this.valueOf() !== that.valueOf()) {
            return false;
        }

        return lodash.isEqual(this, that);
    }

    toString(): string {
        return "" + this.option;
    }
}

export interface TCIApplicationCreateCategoryGroup {
    category: TCIApplicationCreateCategory;
    options: TCITenantAppTypeMetaData[];
}

// tslint:disable-next-line:max-line-length
// Triggers;CRM;ERP;Accounting;FileFormats;Databases;E-Commerce;Amazon;Apache;BigData;Business;Google;HCM;Integration;Interfaces;Marketing;Microsoft;Analytics;Salesforce;SAP;Collaboration;Storage;TIBCO;APIIntegration;MessagingIntegration;EventProcessing;IoTandEdge;MobileWebIntegration;LegacyIntegration;FileIntegration;DataReplication;DataSynchronization;B2B;BusinessAutomations
// any changes in env.MARKETPLACE_PREDEFINED_TAGS will effect the create app dialog tag mapping
// all tags need to be same as the file in ms cic-2/charts/cic-tenant-tci-marketplace/templates/tci-marketplace.yaml
export class TCITenantAppTypeMetaData {
    //  Quickstart
    public static QUICKSTART = new TCITenantAppTypeMetaData(
        0,
        TCIApplicationCreateCategory.QUICKSTART,
        "Get started",
        "To find the right app type for your integration, scroll through the side menu or browse the Quick Start lists. You can create a new app, import an existing one, or implement an API spec.",
        [],
        [],
        "pendo_get_started");

    public static ALL_APP_TYPES = new TCITenantAppTypeMetaData(
        1,
        TCIApplicationCreateCategory.QUICKSTART,
        "All app types",
        "To find the right app type for your integration, scroll through the side menu or browse the Quick Start lists. You can create a new app, import an existing one, or implement an API spec.",
        [],
        [],
        "pendo_all_app_types");

    //  Application Integration
    public static API_BASED_INTEGRATION = new TCITenantAppTypeMetaData(
        2,
        TCIApplicationCreateCategory.APPLICATION_INTEGRATION,
        "API-based Integration",
        "Integrate apps and systems using secure APIs and standard interfaces (e.g., RESTful or Async). Combine multiple APIs for an end-to-end flow. Simplify process integration by combining small steps or datasets within a larger process instead of relying on complex B2B approaches like EDI.",
        ["APIIntegration"],
        [
            // TCIApplicationCreateOption.CREATE_FROM_A_NEW_API_SPEC,
            TCIApplicationCreateOption.IMPLEMENT_AN_OPENAPI_SPEC,
            TCIApplicationCreateOption.CREATE_A_FLOGO_APP,
            TCIApplicationCreateOption.IMPORT_A_FLOGO_APP,
            TCIApplicationCreateOption.CREATE_A_EVENT_APP,
            TCIApplicationCreateOption.IMPORT_A_EVENT_APP,
            TCIApplicationCreateOption.IMPORT_A_NODEJS_APP,
            TCIApplicationCreateOption.IMPORT_A_BUSINESSWORKS_APP,
        ],
        "pendo_api_based_integration",
        TCIApplicationCreateOption.IMPLEMENT_AN_OPENAPI_SPEC);
    public static MESSAGING_EVENT_BASED_INTEGRATION = new TCITenantAppTypeMetaData(
        3,
        TCIApplicationCreateCategory.APPLICATION_INTEGRATION,
        "Messaging/Event-based Integration",
        "Integrate event-based activity in which a system action triggers a message (e.g., from Pub/Sub or WebHook) that’s shared with another system to support real-time data flow or state changes.",
        ["MessagingIntegration"],
        [
            TCIApplicationCreateOption.CREATE_A_FLOGO_APP,
            TCIApplicationCreateOption.IMPORT_A_NODEJS_APP,
            TCIApplicationCreateOption.CREATE_A_EVENT_APP,
            TCIApplicationCreateOption.IMPORT_A_EVENT_APP,
            TCIApplicationCreateOption.IMPORT_A_FLOGO_APP,
            TCIApplicationCreateOption.IMPORT_A_BUSINESSWORKS_APP,
        ],
        "pendo_messaging_event_based_integration",
        TCIApplicationCreateOption.CREATE_A_FLOGO_APP);
    public static EVENT_PROCESSING = new TCITenantAppTypeMetaData(
        4,
        TCIApplicationCreateCategory.APPLICATION_INTEGRATION,
        "Event Processing",
        "Efficiently process multiple events by aggregating events that are related and generating timely responses.",
        ["EventProcessing"],
        [
            TCIApplicationCreateOption.CREATE_A_FLOGO_APP,
            TCIApplicationCreateOption.IMPORT_A_NODEJS_APP,
            TCIApplicationCreateOption.IMPORT_A_FLOGO_APP,
            TCIApplicationCreateOption.IMPORT_A_BUSINESSWORKS_APP,
        ],
        "pendo_event_processing",
        TCIApplicationCreateOption.CREATE_A_FLOGO_APP);
    public static IOT_EDGE_PROCESSING = new TCITenantAppTypeMetaData(
        5,
        TCIApplicationCreateCategory.APPLICATION_INTEGRATION,
        "IoT & Edge Processing",
        "Consume and rapidly process data from IoT networks by using machine learning algorithms on an edge device that’s connected to IoT devices on local networks.",
        ["IoTandEdge"],
        [
            TCIApplicationCreateOption.CREATE_A_FLOGO_APP,
            TCIApplicationCreateOption.IMPORT_A_NODEJS_APP,
            TCIApplicationCreateOption.IMPORT_A_FLOGO_APP,
        ],
        "pendo_iot_and_edge_processing",
        TCIApplicationCreateOption.CREATE_A_FLOGO_APP);
    public static MOBILE_WEB_EVENT_DRIVEN_INTEGRATION = new TCITenantAppTypeMetaData(
        6,
        TCIApplicationCreateCategory.APPLICATION_INTEGRATION,
        "Mobile/Web Event-driven Integration",
        "Integrate with external mobile and web apps using public facing APIs that support real-time, two-way, guaranteed message delivery. ",
        ["MobileWebIntegration"],
        [
            TCIApplicationCreateOption.CREATE_A_FLOGO_APP,
            TCIApplicationCreateOption.IMPORT_A_NODEJS_APP,
            TCIApplicationCreateOption.IMPORT_A_FLOGO_APP,
            TCIApplicationCreateOption.IMPORT_A_BUSINESSWORKS_APP,
        ],
        "pendo_mobile_web_event_driven_integration",
        TCIApplicationCreateOption.CREATE_A_FLOGO_APP);

    //  Data Integration
    public static LEGACY_INTERFACE_INTEGRATION = new TCITenantAppTypeMetaData(
        7,
        TCIApplicationCreateCategory.DATA_INTEGRATION,
        "Legacy Interface Integration",
        "Integrate with legacy systems that don’t expose standardized APIs (e.g., mainframe environments or systems that use SOAP, XML, or non-standard interfaces).",
        ["LegacyIntegration"],
        [
            TCIApplicationCreateOption.IMPORT_A_BUSINESSWORKS_APP,
            TCIApplicationCreateOption.CREATE_A_EVENT_APP,
            TCIApplicationCreateOption.IMPORT_A_EVENT_APP,
        ],
        "pendo_legacy_interface_integration",
        TCIApplicationCreateOption.IMPORT_A_BUSINESSWORKS_APP);
    public static FILE_BASED_INTEGRATION = new TCITenantAppTypeMetaData(
        8,
        TCIApplicationCreateCategory.DATA_INTEGRATION,
        "File-based Integration",
        "Pass files between different databases or operating systems without having to connect directly to them. Avoid multiple API calls when transferring large amounts of data.",
        ["FileIntegration"],
        [
            TCIApplicationCreateOption.IMPORT_A_BUSINESSWORKS_APP,
            TCIApplicationCreateOption.CREATE_A_SCHEDULED_APP,
            TCIApplicationCreateOption.IMPORT_A_SCHEDULED_APP,
        ],
        "pendo_file_based_integration",
        TCIApplicationCreateOption.IMPORT_A_BUSINESSWORKS_APP);
    public static DATA_REPLICATION = new TCITenantAppTypeMetaData(
        9,
        TCIApplicationCreateCategory.DATA_INTEGRATION,
        "Data Replication",
        "Create identical dataset copies.",
        ["DataReplication"],
        [
            TCIApplicationCreateOption.CREATE_A_REPLICATION_APP,
            TCIApplicationCreateOption.CREATE_A_FLOGO_APP,
            TCIApplicationCreateOption.IMPORT_A_NODEJS_APP,
            TCIApplicationCreateOption.IMPORT_A_FLOGO_APP,
            TCIApplicationCreateOption.IMPORT_A_BUSINESSWORKS_APP,
        ],
        "pendo_data_replication",
        TCIApplicationCreateOption.CREATE_A_REPLICATION_APP);
    public static DATA_SYNCHRONIZATION_AND_MIGRATION = new TCITenantAppTypeMetaData(
        10,
        TCIApplicationCreateCategory.DATA_INTEGRATION,
        "Data synchronization and migration",
        "Migrate data from source systems to a target system when retiring the source systems. Synchronize data between multiple sources based on event triggers (queue-based, webhook, or application-based) or according to a schedule (determined by field flags, CDC/Net-Change, snapshots, or file comparisons).",
        ["DataSynchronization"],
        [
            TCIApplicationCreateOption.CREATE_A_SCHEDULED_APP,
            TCIApplicationCreateOption.IMPORT_A_SCHEDULED_APP,
            TCIApplicationCreateOption.CREATE_A_FLOGO_APP,
            TCIApplicationCreateOption.IMPORT_A_NODEJS_APP,
            TCIApplicationCreateOption.IMPORT_A_FLOGO_APP,
            TCIApplicationCreateOption.IMPORT_A_BUSINESSWORKS_APP,
        ],
        "pendo_data_synchronization_and_migration",
        TCIApplicationCreateOption.CREATE_A_SCHEDULED_APP);
    public static STANDARD_PROTOCOL_BASED_B2B = new TCITenantAppTypeMetaData(
        11,
    TCIApplicationCreateCategory.DATA_INTEGRATION,
        "Standard Protocol-based B2B",
        "Allow users to leverage protocols and standards-based communication for EDI and B2B integrations through connectors, with validation steps and observability into all stages of the transactions.",
        ["B2B"],
        [
            TCIApplicationCreateOption.IMPORT_A_BUSINESSWORKS_APP,
            TCIApplicationCreateOption.CREATE_A_FLOGO_APP,
            TCIApplicationCreateOption.IMPORT_A_NODEJS_APP,
            TCIApplicationCreateOption.IMPORT_A_FLOGO_APP,
        ],
        "pendo_standard_protocol_based_b2b",
        TCIApplicationCreateOption.IMPORT_A_BUSINESSWORKS_APP);

    //  Process Automation
    public static BUSINESS_AUTOMATIONS = new TCITenantAppTypeMetaData(
        12,
        TCIApplicationCreateCategory.PROCESS_AUTOMATION,
        "Business Automations",
        "Empower users across your business to streamline and automate business processes using an intuitive, no-code interface.",
        ["BusinessAutomations"],
        [
            TCIApplicationCreateOption.CREATE_A_LIVEAPPS_APP,
            TCIApplicationCreateOption.CREATE_A_FLOGO_APP,
            TCIApplicationCreateOption.IMPORT_A_FLOGO_APP,
            // TCIApplicationCreateOption.IMPORT_A_LIVE_APPS_APP,
        ],
        "pendo_business_automations",
        TCIApplicationCreateOption.CREATE_A_LIVEAPPS_APP);

    public static SCRATCH_APPS = new TCITenantAppTypeMetaData(
        13,
        TCIApplicationCreateCategory.SCRATCH,
        "Apps",
        "",
        [],
        [
            TCIApplicationCreateOption.CREATE_A_FLOGO_APP,
            TCIApplicationCreateOption.IMPORT_A_FLOGO_APP,
            TCIApplicationCreateOption.CREATE_A_SCHEDULED_APP,
            TCIApplicationCreateOption.IMPORT_A_SCHEDULED_APP,
            TCIApplicationCreateOption.CREATE_A_REPLICATION_APP,
            TCIApplicationCreateOption.CREATE_A_EVENT_APP,
            TCIApplicationCreateOption.IMPORT_A_EVENT_APP,
            TCIApplicationCreateOption.CREATE_A_LIVEAPPS_APP,
            // TCIApplicationCreateOption.IMPORT_A_LIVE_APPS_APP,
            TCIApplicationCreateOption.IMPORT_A_NODEJS_APP,
            TCIApplicationCreateOption.IMPORT_A_BUSINESSWORKS_APP,
        ],
        "pendo_apps");

    public static SCRATCH_APIS = new TCITenantAppTypeMetaData(
        14,
        TCIApplicationCreateCategory.SCRATCH,
        "APIs",
        "",
        [],
        [
            // TCIApplicationCreateOption.CREATE_FROM_A_NEW_API_SPEC,
            TCIApplicationCreateOption.IMPLEMENT_AN_OPENAPI_SPEC,
            TCIApplicationCreateOption.IMPORT_A_GRAPHQL_SCHEMA,
        ],
        "pendo_apis");

    private static allItems: TCIApplicationCreateCategoryGroup[] = [
        {
            category: TCIApplicationCreateCategory.QUICKSTART,
            options: [
                TCITenantAppTypeMetaData.QUICKSTART,
                TCITenantAppTypeMetaData.ALL_APP_TYPES,
            ]
        },
        {
            category: TCIApplicationCreateCategory.APPLICATION_INTEGRATION,
            options: [
                TCITenantAppTypeMetaData.API_BASED_INTEGRATION,
                TCITenantAppTypeMetaData.MESSAGING_EVENT_BASED_INTEGRATION,
                TCITenantAppTypeMetaData.EVENT_PROCESSING,
                TCITenantAppTypeMetaData.IOT_EDGE_PROCESSING,
                TCITenantAppTypeMetaData.MOBILE_WEB_EVENT_DRIVEN_INTEGRATION,
            ]
        },
        {
            category: TCIApplicationCreateCategory.DATA_INTEGRATION,
            options: [
                TCITenantAppTypeMetaData.LEGACY_INTERFACE_INTEGRATION,
                TCITenantAppTypeMetaData.FILE_BASED_INTEGRATION,
                TCITenantAppTypeMetaData.DATA_REPLICATION,
                TCITenantAppTypeMetaData.DATA_SYNCHRONIZATION_AND_MIGRATION,
                TCITenantAppTypeMetaData.STANDARD_PROTOCOL_BASED_B2B,
            ]
        },
        {
            category: TCIApplicationCreateCategory.PROCESS_AUTOMATION,
            options: [
                TCITenantAppTypeMetaData.BUSINESS_AUTOMATIONS,
            ]
        }
    ];

    public static getAllItems(): TCIApplicationCreateCategoryGroup[] {
        return TCITenantAppTypeMetaData.allItems;
    }

    public static getScratchItems(): TCITenantAppTypeMetaData[] {
        return [
            TCITenantAppTypeMetaData.SCRATCH_APPS,
            TCITenantAppTypeMetaData.SCRATCH_APIS
        ];
    }

    public static getTenantTypes(buttons: TCIApplicationCreateOption[]): String[] {
        const tenantTypes = [];
        buttons.forEach(button => {
            if (!tenantTypes.includes(button.type)) {
                tenantTypes.push(button.type.toString());
            }
        });
        return tenantTypes;
    }

    valueOf(): number {
        return this.option;
    }

    equals(that: any): boolean {
        // Shortcut for trivial case
        if (this === that) {
            return true;
        }

        // If the that object is not a set, it is not equal to this one.
        // We use instanceof to allow any subclass of Set.
        // We could relax this test if we wanted true duck-typing.
        // Or we could strengthen it to check this.constructor == that.constructor
        // Note that instanceof properly rejects null and undefined values
        if (!(that instanceof TCITenantAppTypeMetaData)) {
            return false;
        }
        // If two sets don't have the same size, they're not equal

        if (this.valueOf() !== that.valueOf()) {
            return false;
        }

        return lodash.isEqual(this, that);
    }

    constructor(
        public option: number,
        public category: TCIApplicationCreateCategory,
        public label: string,
        public description: string,
        public mkTags: string[],
        public buttons: TCIApplicationCreateOption[],
        public pendoSelector: string,
        // recommendOption is for the green tick
        public recommendOption?: TCIApplicationCreateOption,
        // defaultOption is for high light the default item, defaultOption > recommendOption > buttons[0]
        public defaultOption?: TCIApplicationCreateOption
    ) {
    }
}
